import React, { memo, useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';

import WriterForm from '../writer-form/WriterForm';
import validate from '../../../../../utils/validate';
import { writerFormYopValidation } from '../writer-form/validations';
import { editWriter, getWriter } from '../../../../../redux/settings/scout/scoutSettingsActions';
import { resetEditableWriter } from '../../../../../redux/settings/scout/scoutSettingsReducer';

import scss from './EditWriter.module.scss';

const EditWriter = () => {
  const { t } = useTranslation('settings');
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();

  const editableWriter = useSelector((state) => state.scoutSettings.editableWriter);

  const editWriterInitialValues = useMemo(
    () => ({
      writerName: editableWriter.writerName ?? '',
      language: editableWriter.language ?? '',
      writerColor: editableWriter.writerColor ?? '',
      writerPhrase: editableWriter.writerPhrase ?? '',
    }),
    [editableWriter],
  );

  const handleEditWriter = useCallback(
    async (values) => {
      try {
        await dispatch(editWriter({ id, values })).then(() => {
          navigate('/settings/scout');
        });
      } catch (error) {
        console.error(error);
      }
    },
    [dispatch, navigate, id],
  );

  useEffect(() => {
    if (id) {
      dispatch(getWriter({ id }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    return () => {
      dispatch(resetEditableWriter());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={scss.pageWrapper}>
      <h2 className={scss.title}>{t('editWriter')}</h2>

      <Form
        initialValues={editWriterInitialValues}
        onSubmit={handleEditWriter}
        validate={(values) => validate(values, writerFormYopValidation())}
        subscription={{ submitting: true, pristine: true }}
        render={({ handleSubmit }) => <WriterForm handleSubmit={handleSubmit} disableLanguage />}
      />
    </div>
  );
};

export default memo(EditWriter);
